// extracted by mini-css-extract-plugin
export default {"ownerSection":"owner-section_ownerSection__mTX2b"};